import UnsupportedAuthenticationStrengthAlert from './UnsupportedAuthenticationStrengthAlert'

export default UnsupportedAuthenticationStrengthAlert
